/** localStorage is only for "already showed the trial popup today". Access stays on the API. */

function calendarDateLocal() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function trialPopupStorageKey(userId) {
  return `minutepay.trialPopup.${userId}`;
}

export function wasTrialPopupShownToday(userId) {
  if (!userId) return false;
  try {
    return localStorage.getItem(trialPopupStorageKey(userId)) === calendarDateLocal();
  } catch {
    return false;
  }
}

export function markTrialPopupShownToday(userId) {
  if (!userId) return;
  try {
    localStorage.setItem(trialPopupStorageKey(userId), calendarDateLocal());
  } catch {
    /* ignore quota / private mode */
  }
}

/** Temporary verify flag: /dashboard?trialPopup=1 skips the once-per-day check. */
export function isTrialPopupForced() {
  try {
    return new URLSearchParams(window.location.search).get("trialPopup") === "1";
  } catch {
    return false;
  }
}
